let audio,
    gameFrame,
    isFullscreen = false,
    displayTimer = null,
    selectedAnswer = null,
    correctAnswer = '',
    displayTime = 10,
    gameImage = '';

class MemoryDetailGame {
    constructor() {
        this.displayPhase = document.querySelector('[data-phase="display"]');
        this.questionPhase = document.querySelector('[data-phase="question"]');
        this.resultPhase = document.querySelector('[data-phase="result"]');
        this.timerElement = document.querySelector('[data-timer]');
        this.answersContainer = document.querySelector('.game__memory-answers');

        // Pobierz dane z window
        if (window.memoryDetailData) {
            displayTime = window.memoryDetailData.displayTime;
            correctAnswer = window.memoryDetailData.correctAnswer;
            gameImage = window.memoryDetailData.gameImage;
        }

        this.init();
    }

    init() {
        // Rozpocznij timer wyświetlania obrazu
        this.startDisplayPhase();

        // Dodaj event listeners dla odpowiedzi
        if (this.answersContainer) {
            const answerButtons = this.answersContainer.querySelectorAll('.game__memory-answer');
            answerButtons.forEach(button => {
                button.addEventListener('click', () => this.selectAnswer(button));
            });
        }
    }

    startDisplayPhase() {
        let timeLeft = displayTime;

        // Odtwórz dźwięk startu
        if (audio && audio.start) {
            audio.start.play();
            stopAudioAfterDelay(audio.start, 2000);
        }

        displayTimer = setInterval(() => {
            timeLeft--;

            if (this.timerElement) {
                this.timerElement.textContent = timeLeft;

                // Animacja ostatnich 3 sekund
                if (timeLeft <= 3) {
                    this.timerElement.classList.add('timer-warning');
                    if (audio && audio.drag) {
                        audio.drag.play();
                    }
                }
            }

            if (timeLeft <= 0) {
                clearInterval(displayTimer);
                this.switchToQuestionPhase();
            }
        }, 1000);
    }

    switchToQuestionPhase() {
        // Ukryj fazę wyświetlania
        if (this.displayPhase) {
            this.displayPhase.classList.add('hidden');
        }

        // Pokaż fazę pytania
        if (this.questionPhase) {
            this.questionPhase.classList.remove('hidden');
        }

        // Dźwięk przejścia
        if (audio && audio.drag) {
            audio.drag.play();
            stopAudioAfterDelay(audio.drag, 2000);
        }
    }

    selectAnswer(button) {
        const answerText = button.dataset.answerText;
        const isCorrect = button.dataset.isCorrect === 'true';

        selectedAnswer = {
            text: answerText,
            isCorrect: isCorrect
        };

        // Wyłącz wszystkie przyciski
        const allButtons = this.answersContainer.querySelectorAll('.game__memory-answer');
        allButtons.forEach(btn => {
            btn.disabled = true;
        });

        // Zaznacz wybraną odpowiedź
        button.classList.add('selected');

        // Dźwięk wyboru
        if (isCorrect) {
            button.classList.add('correct');
            if (audio && audio.valid) {
                audio.valid.play();
                stopAudioAfterDelay(audio.valid, 2000);
            }
            gameFrame.style.borderColor = 'green';
        } else {
            button.classList.add('incorrect');
            if (audio && audio.wrong) {
                audio.wrong.play();
                stopAudioAfterDelay(audio.wrong, 2000);
            }
            gameFrame.style.borderColor = 'red';

            // Pokaż poprawną odpowiedź
            allButtons.forEach(btn => {
                if (btn.dataset.isCorrect === 'true') {
                    btn.classList.add('correct');
                }
            });
        }

        // Po 2 sekundach przejdź do wyniku
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
            this.showResult();
        }, 2500);
    }

    showResult() {
        // Ukryj fazę pytania
        if (this.questionPhase) {
            this.questionPhase.classList.add('hidden');
        }

        // Pokaż fazę wyniku
        if (this.resultPhase) {
            this.resultPhase.classList.remove('hidden');
        }

        // Ustaw treść wyniku
        const resultIcon = this.resultPhase.querySelector('[data-result-icon]');
        const resultTitle = this.resultPhase.querySelector('[data-result-title]');
        const resultMessage = this.resultPhase.querySelector('[data-result-message]');

        if (selectedAnswer.isCorrect) {
            if (resultIcon) {
                resultIcon.innerHTML = '<i class="fa fa-check-circle"></i>';
                resultIcon.className = 'result-icon success';
            }
            if (resultTitle) {
                resultTitle.textContent = 'Brawo! Poprawna odpowiedź!';
                resultTitle.className = 'result-title success';
            }
            if (resultMessage) {
                resultMessage.textContent = 'Świetnie zapamiętałeś obraz! Twoja odpowiedź "' + selectedAnswer.text + '" jest prawidłowa.';
            }

            // Dźwięk sukcesu
            if (audio && audio.success) {
                audio.success.play();
                stopAudioAfterDelay(audio.success, 3000);
            }
        } else {
            if (resultIcon) {
                resultIcon.innerHTML = '<i class="fa fa-times-circle"></i>';
                resultIcon.className = 'result-icon error';
            }
            if (resultTitle) {
                resultTitle.textContent = 'Niestety, to nie jest poprawna odpowiedź';
                resultTitle.className = 'result-title error';
            }
            if (resultMessage) {
                resultMessage.innerHTML = 'Wybrałeś: "' + selectedAnswer.text + '"<br>Poprawna odpowiedź to: "' + correctAnswer + '"';
            }

            // Dźwięk błędu
            if (audio && audio.wrong) {
                audio.wrong.play();
                stopAudioAfterDelay(audio.wrong, 3000);
            }
        }
    }

    restart() {
        // Reset zmiennych
        selectedAnswer = null;

        // Usuń klasy z odpowiedzi
        if (this.answersContainer) {
            const answerButtons = this.answersContainer.querySelectorAll('.game__memory-answer');
            answerButtons.forEach(button => {
                button.classList.remove('selected', 'correct', 'incorrect');
                button.disabled = false;
            });
        }

        // Reset faz
        if (this.displayPhase) {
            this.displayPhase.classList.remove('hidden');
        }
        if (this.questionPhase) {
            this.questionPhase.classList.add('hidden');
        }
        if (this.resultPhase) {
            this.resultPhase.classList.add('hidden');
        }

        // Reset timera
        if (this.timerElement) {
            this.timerElement.textContent = displayTime;
            this.timerElement.classList.remove('timer-warning');
        }

        // Reset ramki
        gameFrame.style.borderColor = 'black';

        // Rozpocznij od nowa
        this.startDisplayPhase();
    }
}

// Helper function
function stopAudioAfterDelay(audioElement, delay) {
    setTimeout(() => {
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
        }
    }, delay);
}

// Initialize game function
function initGame() {
    gameFrame = document.querySelector('.game__frame--memory-detail');

    if (!gameFrame) {
        return;
    }

    // Initialize audio
    audio = {
        start: document.getElementById('sound-start'),
        valid: document.getElementById('sound-valid'),
        wrong: document.getElementById('sound-wrong'),
        success: document.getElementById('sound-success'),
        drag: document.getElementById('sound-drag')
    };

    // Initialize game
    const game = new MemoryDetailGame();

    // Fullscreen toggle
    const fullscreenButton = document.querySelector('[data-toggle-fullscreen]');
    if (fullscreenButton) {
        fullscreenButton.addEventListener('click', () => {
            if (!isFullscreen) {
                if (gameFrame.requestFullscreen) {
                    gameFrame.requestFullscreen();
                } else if (gameFrame.webkitRequestFullscreen) {
                    gameFrame.webkitRequestFullscreen();
                } else if (gameFrame.msRequestFullscreen) {
                    gameFrame.msRequestFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-expand');
                fullscreenButton.querySelector('i').classList.add('fa-compress');
                isFullscreen = true;
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-compress');
                fullscreenButton.querySelector('i').classList.add('fa-expand');
                isFullscreen = false;
            }
        });
    }

    // Restart buttons
    const restartButtons = document.querySelectorAll('[data-game-restart]');
    restartButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (displayTimer) {
                clearInterval(displayTimer);
            }
            game.restart();
        });
    });

    // Back button
    const backButton = document.querySelector('[data-backward]');
    if (backButton) {
        backButton.addEventListener('click', () => {
            window.history.back();
        });
    }
}

export default { initGame };




// WEBPACK FOOTER //
// ./src/scripts/game-memory-detail.js